import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import ColorScale from '_class/ColorScale';
import DOMPurify from "dompurify";
import { getPlanAssessments, getAssignmentAssessments } from "actions/studyplans";
import { Collapsible } from "UI";
import { StandingBar } from "UI/Graphs";
import { translate } from '@haldor/ui';
var VerdictAssessmentsDisplay = /*#__PURE__*/function (_Component) {
  /* Class setup */
  function VerdictAssessmentsDisplay(props) {
    var _this;
    _classCallCheck(this, VerdictAssessmentsDisplay);
    _this = _callSuper(this, VerdictAssessmentsDisplay, [props]);
    /* Utils */
    _defineProperty(_this, "getGrade", function (index) {
      if (index == 0) {
        return "F";
      } else if (index == 1) {
        return "E";
      } else if (index == 2) {
        return "C";
      } else if (index == 3) {
        return "A";
      } else {
        return "A";
      }
    });
    /* Lifecycle methods */
    _defineProperty(_this, "componentDidMount", function () {
      var stats = _this.state.stats;
      var entries = _this.getEntries();
      entries.forEach(function (entry) {
        entry.assessments.forEach(function (assessment) {
          var level = _this.getAssessmentLevel(assessment);
          if (level != null) {
            if (stats[level] != null) {
              var current = stats[level].amount;
              stats[level].amount = current + 1;
            }
          }
        });
      });
      _this.setState({
        stats: stats
      });
    });
    _defineProperty(_this, "getEntries", function () {
      var _this$props = _this.props,
        start = _this$props.start,
        end = _this$props.end;
      var assignmentIds = [];
      var planIds = [];
      var assessments = [];

      // Combine assessment results
      if (_this.props.assignments != null && _this.props.assignments.length > 0) {
        _this.props.assignments.forEach(function (assignment) {
          if (assignmentIds.indexOf(assignment.referenceId) == -1) {
            if (start != null && end != null) {
              var created = moment(assignment.created);
              if (created.isSameOrBefore(moment(end), "day") && created.isSameOrAfter(moment(start), "day")) {
                assignmentIds.push(assignment.referenceId);
              }
            } else {
              assignmentIds.push(assignment.referenceId);
            }
          }
        });
        assignmentIds.forEach(function (assignmentId) {
          var assignments = [];
          var referenceTitle = "";
          var feedback = "";
          _this.props.assignments.forEach(function (assignment) {
            if (assignment.referenceId == assignmentId) {
              referenceTitle = assignment.referenceTitle;
              feedback = assignment.feedback;
              assignments.push(assignment);
            }
          });
          var newEntry = {
            referenceId: assignmentId,
            referenceTitle: referenceTitle,
            feedback: feedback,
            referenceType: "assignment",
            assessments: assignments
          };
          assessments.push(newEntry);
        });
      }
      if (_this.props.plans != null && _this.props.plans.length > 0) {
        _this.props.plans.forEach(function (plan) {
          if (planIds.indexOf(plan.referenceId) == -1) {
            if (start != null && end != null) {
              var created = moment(plan.created);
              if (created.isSameOrBefore(moment(end), "day") && created.isSameOrAfter(moment(start), "day")) {
                planIds.push(plan.referenceId);
              }
            } else {
              planIds.push(plan.referenceId);
            }
          }
        });
        planIds.forEach(function (planId) {
          var plans = [];
          var referenceTitle = "";
          var feedback = "";
          _this.props.plans.forEach(function (plan) {
            if (plan.referenceId == planId) {
              referenceTitle = plan.referenceTitle;
              feedback = plan.feedback;
              plans.push(plan);
            }
          });
          var newEntry = {
            referenceId: planId,
            referenceTitle: referenceTitle,
            feedback: feedback,
            referenceType: "plan",
            assessments: plans
          };
          assessments.push(newEntry);
        });
      }
      return assessments;
    });
    _defineProperty(_this, "getAssessmentLevel", function (assessment) {
      var level = null;
      if (assessment.cellId == "F") {
        level = 0;
      } else {
        var _assessment$matrix;
        var row = null;
        assessment === null || assessment === void 0 || (_assessment$matrix = assessment.matrix) === null || _assessment$matrix === void 0 || (_assessment$matrix = _assessment$matrix._ParagraphSet) === null || _assessment$matrix === void 0 || _assessment$matrix.forEach(function (paragraph) {
          var _row = paragraph.rows.find(function (_row) {
            return _row.id == assessment.rowId;
          });
          if (_row != null) {
            row = _row;
          }
        });
        if (row != null) {
          level = row.cells.findIndex(function (_cell) {
            return _cell.id == assessment.cellId;
          });
          level = level + 1;
        }
      }
      return level;
    });
    _defineProperty(_this, "getStatsForEntry", function (entry) {
      var steps = 4;
      var stats = [];
      var colors = new ColorScale(steps).get();
      for (var i = 0; steps > i; i++) {
        stats[i] = {
          amount: 0,
          color: colors[i]
        };
      }
      entry.assessments.forEach(function (assessment) {
        var level = _this.getAssessmentLevel(assessment);
        if (level != null) {
          if (stats[level] != null) {
            var current = stats[level].amount;
            stats[level].amount = current + 1;
          }
        }
      });
      return stats;
    });
    /* Events */
    _defineProperty(_this, "toggleList", function (event) {
      event.preventDefault();
      _this.setState({
        open: !_this.state.open
      });
    });
    /* Render methods */
    _defineProperty(_this, "renderAssessments", function () {
      var entries = _this.getEntries();
      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "assessment-list"
      }, entries.length == 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: "center"
        }
      }, translate('No assessments found')) : null, entries.map(function (entry, index) {
        var stats = _this.getStatsForEntry(entry);
        return /*#__PURE__*/React.createElement("div", {
          key: "verdict-assessment-entry-" + index,
          className: "assessment"
        }, /*#__PURE__*/React.createElement("div", {
          className: "title"
        }, /*#__PURE__*/React.createElement("span", null, entry.referenceType == "plan" ? translate('Plan') : translate('Assignment')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, entry.referenceTitle), /*#__PURE__*/React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: entry.feedback
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "graph-container"
        }, /*#__PURE__*/React.createElement(StandingBar, {
          data: stats,
          heightUnit: 0.5
        })));
      }));
    });
    var _steps = 4;
    var _stats = [];
    var _colors = new ColorScale(_steps).get();
    for (var _i = 0; _steps > _i; _i++) {
      _stats[_i] = {
        amount: 0,
        color: _colors[_i]
      };
    }
    _this.state = {
      stats: _stats,
      open: false
    };
    return _this;
  }
  _inherits(VerdictAssessmentsDisplay, _Component);
  return _createClass(VerdictAssessmentsDisplay, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-assessment-display"
      }, /*#__PURE__*/React.createElement("div", {
        className: "stats-wrapper"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        open: this.state.open
      }, this.renderAssessments())));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    assignments: state.studyplans.assignments,
    plans: state.studyplans.plans,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getPlanAssessments: getPlanAssessments,
  getAssignmentAssessments: getAssignmentAssessments
})(VerdictAssessmentsDisplay);